import { z } from "zod";

import { integerFieldSchema } from "@/utils/common-zod-schemas";
import { ReplayTypeEnum } from "@classview/shared-types";

const addOrganisationSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  licenseId: z.string().min(1, { message: "Pricing plan is required" }),
  concurrency: integerFieldSchema("Concurrency"),
  replay: z.enum([
    ReplayTypeEnum.LITE,
    ReplayTypeEnum.REPLAY,
    ReplayTypeEnum.ADVANCED,
  ] as const),
  isGivenEventAccess: z.boolean().optional(),
  storageInGB: integerFieldSchema("Storage"),
  licenseEndDate: z.date(),
});
type AddOrganisationFormData = z.infer<typeof addOrganisationSchema>;

const updateOrganisationSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
});
type UpdateOrganisationFormData = z.infer<typeof updateOrganisationSchema>;

export { addOrganisationSchema, updateOrganisationSchema };
export type { AddOrganisationFormData, UpdateOrganisationFormData };
